import React, {useEffect} from 'react';
import { useState } from 'react';
import s from './Administrators.mosule.scss';
import {useDeleteCustomerMutation, useGetCustomersQuery} from "../../redux/apis/administratorApi";
import { ReactComponent as Plus } from 'assets/icons/plus.svg';
import { ReactComponent as Edit } from 'assets/icons/edit.svg';
import { ReactComponent as Delete } from 'assets/icons/trash.svg';
import {AddUser} from "components/AddUser/AddUser";
import {ModalGeneral} from "components/Modals/ModalGeneral";
import questionMark from 'assets/images/questionMark.webp';
import {Preloader} from "components/Preloader/Preloader";
import {HeaderSection} from "components/HeaderSection/HeaderSection";
import {AdminTable} from "components/AdminTable/AdminTable";
import {useStatusContext} from "components/StatusProvider";
import {useTranslation} from "react-i18next";

export const Administrators = () => {
    const { data: users } = useGetCustomersQuery({});
    const [query, setQuery] = useState<string>('');
    const [filteredUsers, setFilteredUsers] = useState<any[]>();
    const [addUser, setAddUser] = useState<boolean>();
    const [showModal, setShowModal] = useState<boolean>(false);
    const [idDelete, setIdDelete] = useState<number>();
    const [user, setUser] = useState<any>();
    const { t } = useTranslation();
    const [confirmState, setConfirmState] = useState(false);
    const [role, setRole] = useState<string>();
    const headers = ['ID', t("pagesModal.name"), t("customers.role"), t("customers.email"), ""];
    const { openStatus } = useStatusContext();
    const [delUser, {isLoading: isLoadingDelUser}] = useDeleteCustomerMutation();

    useEffect(() => {
        setFilteredUsers(users);
    }, [users]);

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setQuery(event.target.value);
    };

    if (users?.isFetching || isLoadingDelUser) return <Preloader />

    if (users?.error) {
        if (!confirmState && users?.error?.data.message === 9) {
            openStatus('warning', "status.unfortunately");
        }
    }

    async function deleteUser(){
        const result = await delUser(idDelete);

        if (result.data.message === 7 ) {
            openStatus('success', "status.operationSuccessful");
        }
        setShowModal(false);
    }

    const openDeleteModal = (id: number, role: string) => {
        setIdDelete(id);
        setRole(role);
        setShowModal(true);
    }

    const handleSearch = () => {
        const results = users.filter((user: any) =>
            (user.id && String(user.id).toLowerCase().includes(query.toLowerCase())) ||
            (user.info?.name && String(user.info.name).toLowerCase().includes(query.toLowerCase())) ||
            (user.email && String(user.email).toLowerCase().includes(query.toLowerCase()))
        );

        setFilteredUsers(results);
    };

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    const handleEdit = (user: any) => {
        setUser(user);
        setAddUser(true);
    }

    const handleAddUser = () => {
        setUser(null);
        setAddUser(true);
    }

    const users_view = filteredUsers?.map((user: any) => {
        return (
            <tr key={user.id}>
                <td><span>{user.id}</span></td>
                <td>{user.info.name}</td>
                <td>{user.info.role}</td>
                <td>{user.email}</td>
                <td className={s.icons}>
                    <span
                        className={s.tools_icon}
                        onClick={(ev) => openDeleteModal(user.id, user.info.name)}
                    >
                        <Delete />
                    </span>
                    <span className={s.tools_icon} onClick={() => handleEdit(user)}>
                        <Edit />
                    </span>
                </td>
            </tr>
        )
    })

    if (addUser) {
        return (
            <section className={s.users}>
                {addUser && <AddUser close={setAddUser} user={user} /> }
            </section>
        )
    }

    const description = (
        <>
            {t("customers.wantToDelete")} <span>{role}</span> ? <br />
            {t("customers.loseAllAccess")}
        </>
    );

    return (
        <section className={s.users}>
            <HeaderSection
                title={t("customers.usersText")}
                buttonText={t("customers.addUser")}
                icon={<Plus />}
                onClick={handleAddUser}
                description={t("customers.canAdd")}
            />

            <AdminTable
                title={t("customers.yourUsers")}
                placeholder={t("customers.search")}
                query={query}
                handleInputChange={handleInputChange}
                handleKeyDown={handleKeyDown}
                handleSearch={handleSearch}
                headers={headers}
                data={users_view}
            />

            <ModalGeneral
                showModal={showModal}
                setShowModal={setShowModal}
                image={questionMark}
                buttonRight={deleteUser}
                title={t("customers.deleteAUser")}
                textLeftButton={t("general.cancel")}
                textRightButton={t("general.delete")}
                description={description}
            />
        </section>
    )
}